import { StateService } from "@uirouter/angularjs";
import angular from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../records/server/serverUtility";
import { IReportGroup } from "../../../../../../reporting/interfaces/IReportGroup";
import {
  ConversionModalService,
  vsServiceName as ConversionModalServiceName,
} from "../../../../components/conversionModal";
import { Machine } from "../../../../models/machine";
import { MachineConfiguration } from "../../../../models/machineConfiguration";
import { ProgressiveDefinition } from "../../../../models/progressiveDefinition";

export class MachineDetailConfigurationsComponentController
  implements angular.IOnInit
{
  static $inject = [
    "dateFilter",
    ServerUtilityName,
    "$state",
    ConversionModalServiceName,
    "environment",
  ];

  configurations!: MachineConfiguration[];
  progressiveDefinitions!: ProgressiveDefinition[];
  readonly machine!: Machine;
  readonly reportGroup!: IReportGroup;
  private currentConfiguration: MachineConfiguration | undefined;

  constructor(
    private readonly dateFilter: (d: any) => string | undefined,
    private readonly serverUtility: ServerUtility,
    private readonly $state: StateService,
    private readonly conversionModalService: ConversionModalService,
    private readonly environment: { Date: Date }
  ) {}

  $onInit(): void {
    this.configurations = [...(this.machine.Configs ?? [])];
    this.currentConfiguration = this.configurations.find(
      (c) => c.CurrentConfiguration
    );
    this.configurations.sort((first, second) => second.Order - first.Order);
  }

  async clone() {
    this.$state.go("main.machines.add", {
      modelMachineConfigurationId: this.currentConfiguration?.Id,
      modelMachineId: this.machine.Id,
    });
  }

  changeIsPending(machineConfiguration: MachineConfiguration): boolean {
    const date = machineConfiguration.Date ?? new Date(1900, 1);
    return date > this.environment.Date;
  }

  getHeading(machineConfiguration: MachineConfiguration) {
    const futureChange = this.changeIsPending(machineConfiguration);
    const currentConfiguration = machineConfiguration.CurrentConfiguration;

    return `${machineConfiguration.ChangeType} - ${this.dateFilter(
      machineConfiguration.Date
    )}${currentConfiguration && !futureChange ? " - Current" : ""}${
      futureChange ? " - Pending" : ""
    }`;
  }

  getProgressiveDefinition(
    id: number | undefined
  ): ProgressiveDefinition | undefined {
    return this.progressiveDefinitions.find((p) => p.Id === id);
  }

  async convert() {
    const modalInstance = this.conversionModalService.openModal();
    const result = await modalInstance.result;
    this.$state.go("^.conversion", {
      modelMachineId: result.machineId,
      modelMachineConfigurationId: result.machineConfigurationId,
    });
  }
}
